import { useState, useEffect } from "react";
import { isValid } from "../../../../util/RegEx";

export const useGeneralConfirm = (open, item) => {
    const [adminName, setAdminName] = useState("");

    const [form, setForm] = useState(null);
    const [valid, setValid] = useState(false);

    const onHandleChange = (key, key2, e) => {
        let value = key.includes("uuid") ? e.target.value.trim() : e.target.value;
        let f = form ? form : {};
        f[key] = key2 ? key2 : value;
        key.includes("uuid") ?
            (isValid(value) ? setValid(true) : setValid(false)) :
            (value ? setValid(true) : setValid(false))

        setForm(JSON.parse(JSON.stringify(f)));
    };

    useEffect(() => {
        if (open && item) {
            if(item.admin){
                setAdminName(`${item.admin.gname} ${item.admin.lname} ${item.admin.slname}`);
            } else if(item.customer){
                setAdminName(item.customer);
                setForm(item);
            } else if(item.name){
                setAdminName(item.name);
            } else if(item.action){
			    setForm(JSON.parse(JSON.stringify(item.action)));
            }
        } else {
            setAdminName("");
            setForm(null);
            setValid(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return { onHandleChange, form, valid, adminName };
};
